import { ReactNode } from "react"
import { ChatThreadProvider } from "@/modules/chats/stores/useChatThreadStore"
import { UnsentMessageProvider } from "@/modules/chats/stores/useUnsentMessageStore"

export const ChatProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ChatThreadProvider>
      <UnsentMessageProvider>{children}</UnsentMessageProvider>
    </ChatThreadProvider>
  )
}
